import invariant from 'invariant';
import partition from 'lodash/partition.js';
import isNil from 'lodash/isNil.js';
const pick = (input, fields)=>{
    const [regexps, columns] = partition(fields, (x)=>x instanceof RegExp);
    return Object.keys(input).reduce((reduction, key)=>{
        if (columns.includes(key) || regexps.some((x)=>x.test(key))) {
            reduction[key] = input[key];
        }
        return reduction;
    }, {});
};
const omit = (input, fields)=>{
    const [regexps, columns] = partition(fields, (x)=>x instanceof RegExp);
    return Object.keys(input).reduce((reduction, key)=>{
        if (!columns.includes(key) && regexps.every((x)=>!x.test(key))) {
            reduction[key] = input[key];
        }
        return reduction;
    }, {});
};
export const hierarchifyVDResult = (rows, subTableDefs, options)=>{
    invariant(Array.isArray(rows), 'rows must be an array.');
    invariant(Array.isArray(subTableDefs), 'subTableDefs is missing, must be an array.');
    const omitColumns = options?.omitColumns;
    const pickColumns = options?.pickColumns;
    const getId = options?.getId || ((vdItem)=>vdItem.id);
    invariant(omitColumns === undefined || Array.isArray(omitColumns), 'omitColumns must be an array.');
    invariant(pickColumns === undefined || Array.isArray(pickColumns), 'pickColumns must be an array.');
    const validateDef = (def)=>{
        invariant(def, 'def is missing.');
        invariant(def.tableName, 'tableName is missing.');
        invariant(def.idCol, 'idCol is missing.');
        invariant(Array.isArray(def.columns), 'columns must be an array.');
        if (def.subTables) {
            invariant(Array.isArray(def.columns), 'columns must be an array.');
        }
        (def.subTables || []).forEach(validateDef);
    };
    // Validate subTables.
    subTableDefs.forEach(validateDef);
    const getChildColumns = (childDefs)=>{
        return (childDefs || []).reduce((reduction, def)=>{
            return [
                ...reduction,
                def.idCol,
                ...def.columns,
                ...getChildColumns(def.subTables || [])
            ];
        }, []);
    };
    const childCols = getChildColumns(subTableDefs);
    const updateSubTableData = (row, def, parentItem)=>{
        const { tableName, idCol, columns } = def;
        const childDefs = def.subTables || [];
        if (!Object.prototype.hasOwnProperty.call(row, idCol)) {
            throw new Error(`You have specified an idCol for a subtable which is not included in the data row. Table name: ${tableName}, idCol: ${idCol}.`);
        }
        const id = row[idCol];
        if (!id) {
            return;
        }
        let childItem = parentItem.subTables[tableName].find((x)=>x.id === id);
        if (!childItem) {
            childItem = {
                id,
                text: '',
                data: pick(row, [
                    idCol,
                    ...columns
                ]),
                subTables: childDefs.reduce((r, childDef)=>{
                    r[childDef.tableName] = [];
                    return r;
                }, {})
            };
            parentItem.subTables[tableName].push(childItem);
        }
        childDefs.forEach((childDef)=>{
            updateSubTableData(row, childDef, childItem);
        });
    };
    return rows.reduce((reduction, row)=>{
        const id = getId(row);
        if (isNil(id)) {
            throw new Error('You have specified a getId method that didn\'t return a value.');
        }
        let item = reduction.find((x)=>x.id === id);
        if (!item) {
            item = {
                id,
                text: row.text,
                data: pickColumns ? pick(row.data, pickColumns) : omit(row.data, [
                    ...omitColumns || [],
                    ...childCols
                ]),
                subTables: subTableDefs.reduce((r, childDef)=>{
                    r[childDef.tableName] = [];
                    return r;
                }, {})
            };
            reduction.push(item);
        }
        subTableDefs.forEach((childDef)=>{
            updateSubTableData(row.data, childDef, item);
        });
        return reduction;
    }, []);
};
